import React from "react";
import { C, inp, lbl } from "../../../../lib/styles.js";
import { fl } from "../../../../lib/utils.js";

export default function DeliverableRequirementsTab({ job, updateJobFields, editing }) {
  return (
    <div>
      <label style={lbl}>Deliverable Requirements</label>
      {editing ? (
        <textarea
          style={{ ...inp, resize: "vertical", minHeight: 120, fontFamily: fl, fontSize: 12 }}
          rows={6}
          value={job.deliverableRequirements || ""}
          onChange={(e) => updateJobFields({ deliverableRequirements: e.target.value })}
          placeholder="Describe deliverable requirements, file formats, specifications, resolution needs..."
        />
      ) : (
        <div
          style={{
            fontSize: 12,
            color: job.deliverableRequirements ? C.text : `${C.muted}55`,
            fontFamily: fl,
            whiteSpace: "pre-wrap",
          }}
        >
          {job.deliverableRequirements || "-"}
        </div>
      )}
      <div style={{ fontSize: 10, color: C.muted, marginTop: 8 }}>
        Structured deliverable fields coming soon — equipment-specific file type options will be added here.
      </div>
    </div>
  );
}
